import { ReactNode, Suspense } from "react";
import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { getComponentFromPath } from "@kaltura/mediaspace-shared-utils";
import { ErrorBoundary } from "../error-boundary/ErrorBoundary";

type CustomComponentProps<PropsT extends object, InjectedPropsT extends object> = {
    component: Pick<KmsTypeComponent<PropsT, InjectedPropsT>, "component" | "props" | "_fakeProp">;
    errorFallback?: ReactNode;
} & InjectedPropsT;

/**
 * Render a KmsTypeComponent object with an error boundary.
 */
export const CustomComponent = <PropsT extends object, InjectedPropsT extends object>({
    component: { component, props },
    errorFallback,
    ...autoProps
}: CustomComponentProps<PropsT, InjectedPropsT>) => {
    const Component = getComponentFromPath(component);

    return (
        <ErrorBoundary fallback={errorFallback}>
            <Suspense fallback={<></>}>
                <Component {...props} {...(autoProps as InjectedPropsT)} />
            </Suspense>
        </ErrorBoundary>
    );
};
